<!-- Button to open modal -->
<button type="button" class="btn btn-info ml-2" (click)="openBulkUploadModal()" style="margin-top: 5px;">
  <i class="fas fa-upload"></i>
  Bulk Upload Ideals
</button>

<!-- Modal -->
<ng-template #bulkUploadModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Bulk Upload Ideals</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()" >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form>
      <!-- Merchant Group Selection -->
      <div class="form-group">
        <label for="merchantGroup">Select Merchant Group *</label>
        <ng-select
          [items]="merchantGroups"
          bindLabel="name"
          bindValue="id"
          placeholder="Select a merchant group"
          [(ngModel)]="selectedMerchantGroup"
          (change)="onMerchantGroupChange()"
          name="merchantGroup"
          id="merchantGroup"
          [disabled]="isUploading">
        </ng-select>
      </div>

      <!-- Merchant Selection -->
      <div class="form-group">
        <label for="merchant">Select Merchant</label>
        <ng-select
          [items]="merchants"
          bindLabel="name"
          placeholder="Select a merchant"
          [(ngModel)]="selectedMerchant"
          (change)="onMerchantChange($event)"
          name="merchant"
          id="merchant"
          [disabled]="!selectedMerchantGroup || isUploading">
        </ng-select>
      </div>

      <!-- Template Selection (visible when merchant is selected) -->
      <div class="form-group" *ngIf="selectedMerchant">
        <label for="template">Select Template *</label>
        <ng-select
          [items]="merchantTemplates"
          bindLabel="configName"
          bindValue="id"
          placeholder="Select a template"
          [(ngModel)]="selectedTemplate"
          name="template"
          id="template"
          [disabled]="isUploading">
        </ng-select>
        <small class="form-text text-muted" *ngIf="isTiktokMerchant">
          Ideals will be uploaded and pushed to this TikTok merchant automatically
        </small>
      </div>

      <!-- File Upload Section -->
      <div class="form-group">
        <label for="fileUpload">Upload Images *</label>
        <div class="custom-file-upload">
          <input
            type="file"
            id="fileUpload"
            multiple
            accept=".png,.jpeg,.jpg"
            (change)="onFileSelected($event)"
            class="file-input"
            [disabled]="isUploading">
          <label for="fileUpload" class="file-label">
            <i class="fas fa-cloud-upload-alt"></i>
            Choose Files (PNG, JPEG, JPG)
          </label>
        </div>
        <small class="form-text text-muted">
          Select multiple image files (PNG, JPEG, JPG) to upload as ideals
        </small>
      </div>

      <!-- Selected Files Display (before upload starts) -->
      <div class="selected-files" *ngIf="selectedFiles.length > 0 && uploadResults.length === 0">
        <h6>Selected Files ({{selectedFiles.length}}):</h6>
        <div class="file-list">
          <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
            <div class="file-info">
              <i class="fas fa-image"></i>
              <span class="file-name">{{file.name}}</span>
              <span class="file-details">
                {{getFileType(file)}} - {{getFileSize(file)}}
              </span>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              (click)="removeFile(i)"
              [disabled]="isUploading">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Real-time Upload Results -->
      <div class="upload-results" *ngIf="uploadResults.length > 0">
        <!-- Summary -->
        <div class="upload-summary">
          <h6>
            Progress: {{summaryCount.success + summaryCount.error}} / {{summaryCount.total}}
          </h6>
          <div class="summary-badges">
            <span class="badge badge-success" *ngIf="summaryCount.success > 0">
              {{summaryCount.success}} succeeded
            </span>
            <span class="badge badge-danger" *ngIf="summaryCount.error > 0">
              {{summaryCount.error}} failed
            </span>
          </div>
        </div>

        <!-- Progress bar -->
        <div class="progress mb-3">
          <div class="progress-bar"
               [class.bg-success]="!isUploading && summaryCount.error === 0"
               [class.bg-warning]="!isUploading && summaryCount.error > 0"
               [class.progress-bar-striped]="isUploading"
               [class.progress-bar-animated]="isUploading"
               role="progressbar"
               [style.width.%]="((summaryCount.success + summaryCount.error) / summaryCount.total) * 100">
          </div>
        </div>

        <!-- Per-file results -->
        <div class="file-list">
          <div class="file-item" *ngFor="let result of uploadResults"
               [ngClass]="{
                 'result-success': result.status === 'success',
                 'result-error': result.status === 'error',
                 'result-active': result.status === 'uploading' || result.status === 'pushing'
               }">
            <div class="file-info">
              <i class="fas fa-spinner fa-spin text-primary" *ngIf="result.status === 'uploading' || result.status === 'pushing'"></i>
              <i class="fas fa-check-circle text-success" *ngIf="result.status === 'success'"></i>
              <i class="fas fa-times-circle text-danger" *ngIf="result.status === 'error'"></i>
              <i class="fas fa-hourglass-half text-muted" *ngIf="result.status === 'pending'"></i>
              <span class="file-name">{{result.fileName}}</span>
            </div>
            <div class="result-status">
              <span class="status-text" *ngIf="result.status === 'uploading'">Uploading...</span>
              <span class="status-text" *ngIf="result.status === 'pushing'">Pushing to merchant...</span>
              <span class="status-text text-success" *ngIf="result.status === 'success'">{{result.message}}</span>
              <span class="status-text text-danger" *ngIf="result.status === 'error'">{{result.message}}</span>
              <span class="status-text text-muted" *ngIf="result.status === 'pending'">Waiting...</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" [disabled]="isUploading">
      {{ uploadResults.length > 0 && !isUploading ? 'Close' : 'Cancel' }}
    </button>
    <button type="button"
            class="btn btn-primary"
            (click)="uploadFiles()"
            [disabled]="!canUpload || isUploading"
            *ngIf="uploadResults.length === 0 || isUploading">
      <i class="fas fa-upload" *ngIf="!isUploading"></i>
      <i class="fas fa-spinner fa-spin" *ngIf="isUploading"></i>
      {{ isUploading ? 'Processing...' : 'Upload Files' }}
    </button>
  </div>
</ng-template>
